export default __webpack_public_path__ + "static/media/furgonetka.95e7942b.svg";